import { memo, VFC, useState } from 'react';
import {
  Center,Heading,Box,Flex,Text,
} from '@chakra-ui/react';
import { CaseTable } from '../molecules/CaseTable';

export const CaseView: VFC = memo(() => {
  const [ title ] = useState('問い合わせ履歴');
  const [ dtStr, setDTStr ] = useState("");
  
  return (
    <Center> 
      <Box
        w="100%"
        bg="white"
        shadow="md"
        marginTop="10px"
        marginRight="10px"
        borderRadius="10px"
      >
        <Flex>
          <Heading size="md" margin="10px">
            <Flex>{`■${title}`}<Text color="green">{dtStr}</Text></Flex>
          </Heading> 
        </Flex>
        <Box margin="10px">
          <CaseTable setDTStr={setDTStr} />  
        </Box>
      </Box>  
    </Center>
  );
});